import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import useSystem, { defaultRemindSetting } from 'hooks/business/system/useSystem';
import SwitchWithText from './SwitchWithText';
import { SoundRemindSelect } from './SoundRemindSelect';

export const RemindSetting = () => {
  const { t } = useTranslate();
  const {
    systemSetting: { messageRemind },
    handleMessageRemindSettingChange,
  } = useSystem();

  const MessageConfigMap = {
    soundRemind: {
      title: t('ViewSystem.system.remind.sound'),
      tip: (isOpen: boolean) =>
        isOpen
          ? t('ViewSystem.system.remind.sound.will.off.tips')
          : t('ViewSystem.system.remind.sound.will.on.tips'),
    },
    popupRemind: {
      title: t('ViewSystem.system.remind.notic'),
      tip: (isOpen: boolean) =>
        isOpen
          ? t('ViewSystem.system.remind.notic.will.off.tips')
          : t('ViewSystem.system.remind.notic.will.on.tips'),
    },
    flashRemind: {
      title: t('ViewSystem.system.remind.flash.title'),
      tip: (isOpen: boolean) =>
        isOpen
          ? t('ViewSystem.system.remind.flash.open')
          : t('ViewSystem.system.remind.flash.close'),
    },
    reviewRemind: {
      title: t('ViewSystem.中差评通知'),
      tip: (isOpen: boolean) =>
        isOpen
          ? t('ViewSystem.关闭后，当有符合的中差评价，不再进行右上角弹出通知。')
          : t('ViewSystem.开启后，当有符合的中差评价，会进行右上角弹出通知。'),
    },
    refundRemind: {
      title: t('ViewSystem.退单通知'),
      tip: (isOpen: boolean) =>
        isOpen
          ? t('ViewSystem.关闭后，当店铺有退货退款单时，不再进行右上角弹出通知。')
          : t('ViewSystem.开启后，当店铺有退货退款单时，会进行右上角弹出通知。'),
    },
  };

  return (
    <>
      <DecorateTitle>{t('ViewSystem.system.remind')}</DecorateTitle>
      {Object.entries(MessageConfigMap).map(([key, props]) => {
        const {
          [key as keyof typeof MessageConfigMap]: value = defaultRemindSetting[
            key as keyof typeof MessageConfigMap
          ],
        } = messageRemind;
        const { tip } = props;
        return (
          <>
            <div className="flex items-center gap-4">
              <SwitchWithText
                key={key}
                value={value}
                onChange={(checked) =>
                  handleMessageRemindSettingChange({
                    ...messageRemind,
                    [key]: checked,
                  })
                }
                checkedChildren={t('antd.switch.on.text')}
                unCheckedChildren={t('antd.switch.off.text')}
                {...props}
              />
              {key === 'soundRemind' && <SoundRemindSelect />}
            </div>
            <div>
              <section className="inline-block bg-[#f0f7ff] rounded mx-auto my-[10px] p-3">
                {tip(!!value)}
              </section>
            </div>
          </>
        );
      })}
    </>
  );
};
